import "./CooperationPage.css";
import Cover from "../../components/Cover/Cover";
import coverImage from "../../assets/images/mainCoverImage.webp";
import coverImageMobile from "../../assets/images/mainCoverImageMobile.webp";

const CooperationPage = () => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;
  return (
    <div className="page">
      <title>
        Співпраця — ТОВ «Миколаївмолпром» | Виробник молочної продукції Pastoral
      </title>
      <meta
        name="description"
        content="Запрошуємо до співпраці з ТОВ «Миколаївмолпром» — виробником натуральної молочної продукції під ТМ «Pastoral» та «Мумуля». Виробництво Private label, участь у тендерах, постачання до торговельних мереж, закупівля пакування та компонентів, нові партнерства і вакансії."
      />

      <Cover text={"“Pastoral” - Французькі традиції"} src={coverImageToUse} />
      <div className="cooperation__page-cooperation">
        <h1 className="cooperation__page-cooperation-title mont-m">
          Запрошення до співпраці:
        </h1>
        <p className="cooperation__page-cooperation-text int-r-21">
          Приєднуйтесь до проєктів від ТМ «Pastoral» та ТМ «Мумуля», до
          створення нових молочних продуктів, відкриття нових виробничих
          дільниць і росту продаж. Для Вас у нас підготовлено ультраексклюзивне
          à la carte можливостей для співпраці. Ми приймаємо участь у  тендерних
          поставках, виготовляємо продукцію під Private label, постачаємо
          ексклюзивну продукцію до торговельних мереж. Ми розробляємо нові
          продукти, тому зацікавлені в закупівлі пакування, компонентів,
          промислового обладнання та відкриті до нових партнерств.
        </p>
        <h2 className="cooperation__page-cooperation-subtitle mont-m">
          Телефонуйте:
        </h2>
        <div className="cooperation__page-cooperation-text int-r-21">
          Головний Технолог, Валентина Вікторівна <br />{" "}
          <a
            className="cooperation__page-cooperation-link"
            href="tel:+380952881025"
          >
            +38(095)288–10-25
          </a>
        </div>
        <div className="cooperation__page-cooperation-text int-r-21">
          Менеджер з постачання, Гросу Дмитро Андрійович <br />{" "}
          <a
            className="cooperation__page-cooperation-link"
            href="tel:+380673159153"
          >
            +38(067)315-91-53
          </a>
        </div>
      </div>
      <div className="cooperation__page-cooperation-wrapper">
        <div className="cooperation__page-team">
          <h1 className="cooperation__page-team-title mont-m">
            Запрошення до команди:
          </h1>
          <p className="cooperation__page-cooperation-text int-r-21">
            Запрошуємо Вас стати частиною команди «Доманівського
            маслосирзаводу», місця там, де працюють з любов’ю до молока та
            повагою до людей. Доманівський маслосирзавод постійно розвивається,
            саме тому наша команда постійно потребує нових працівників,
            талановитих та відповідальних. Ми цінуємо внесок кожного у розвиток
            і успіх підприємства, адже зростання та досягнення - це спільний
            шлях, де важливий кожен крок.
          </p>
          <h2 className="cooperation__page-cooperation-subtitle mont-m">
            Телефонуйте:
          </h2>
          <div className="cooperation__page-cooperation-text int-r-21">
            Начальник відділу кадрів, Наталія Юріївна <br />{" "}
            <a
              className="cooperation__page-cooperation-link"
              href="tel:+380982074160"
            >
              +38(098)207-41-60
            </a>
          </div>
          <div className="cooperation__page-cooperation-text int-r-21">
            Начальник Виробництва, Наталія Іванівна <br />{" "}
            <a
              className="cooperation__page-cooperation-link"
              href="tel:+380507004825"
            >
              +38(050)700–48-25
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CooperationPage;
